import { DialogActions, DialogContent, FormControl, TextField } from "@mui/material";
import DialogHESP from "../DialogHESP/DialogHESP";
import DialogFooterWithLoading from "../Loading/DialogFooterWithLoading";
import gql from "graphql-tag";
import { useMutation } from "react-apollo";
import { UpdateDatacenter, UpdateDatacenterVariables } from "./__generated__/UpdateDatacenter";
import { toast } from "react-toastify";
import { useState } from "react";
import HESPFormLabel from "../HESPFormLabel/HESPFormLabel";
import { navigate } from "@reach/router";
import { THEO_ID } from "../../views/App/AppRoot";

interface Props {
    id: string;
    open: boolean;
    onClose: () => void;
}

export const UPDATE_DATACENTER = gql`
    mutation UpdateDatacenter($input: UpdateDatacenterInput!) {
        updateDatacenter(input: $input) {
            id
        }
    }
`;

export default function TLAUpdateDatacenterIdDialog({ id, open, onClose }: Props) {
    const [newId, setNewId] = useState<string>(id);

    const [updateDc, { loading }] = useMutation<UpdateDatacenter, UpdateDatacenterVariables>(UPDATE_DATACENTER);

    async function onUpdateDatacenterId(): Promise<void> {
        try {
            await updateDc({
                variables: {
                    input: {
                        id,
                        newId,
                    },
                },
            });
            toast.success("Datacenter ID updated!");
            navigate(`/app/${THEO_ID}/tla/data-centers/${newId}`);
            onClose();
        } catch {
            toast.error("Something went wrong");
        }
    }

    return (
        <DialogHESP
            title="Update datacenter ID"
            onClose={onClose}
            open={open}
            content={
                <>
                    <DialogContent>
                        <FormControl fullWidth>
                            <HESPFormLabel label="New ID" />
                            <TextField
                                placeholder="New ID"
                                fullWidth
                                value={newId}
                                onChange={(e) => setNewId(e.target.value)}
                            />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            onActionClick={onUpdateDatacenterId}
                            isLoading={loading}
                            onCancelClick={onClose}
                            disabled={newId.trim().length === 0}
                            defaultText={"Update"}
                            loadingText={"Updating..."}
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
